export default "__VITE_PUBLIC_ASSET__3b8c5cd4__"